export class IFrameSrcGetter {
    private getSearchResultUrlParams() {
        const params = new URL(window.location.href).searchParams;
        return {
            trimId: params.has("trimId") ? params.get("trimId") : undefined,
            placement: params.has("placement") ? params.get("placement") : undefined,
            isIDKTrim: params.has("isIDKTrim") ? params.get("isIDKTrim") === "true" : undefined,
            width: params.has("width") ? params.get("width") : undefined,
            aspectRatio: params.has("aspectRatio") ? params.get("aspectRatio") : undefined,
            diameter: params.has("diameter") ? params.get("diameter") : undefined,
            storeId: params.has("storeId") ? params.get("storeId") : undefined,
            dealerSlug: params.has("dealerSlug") ? params.get("dealerSlug") : undefined,
        };
    }
    public get() {
        const {
            tt: {
                config: { iframeBaseUrl },
            },
        } = window;
        const { trimId, placement, diameter, width, aspectRatio, storeId, dealerSlug, isIDKTrim } =
            this.getSearchResultUrlParams();
        if (trimId && placement && dealerSlug && storeId) {
            let iframePath = `/${dealerSlug}/srp/shop-by-car/${trimId}/${placement}/${storeId}?isIframe=true&hideLogo=true`;
            if (isIDKTrim) iframePath = `${iframePath}&isIDKTrim=true`;
            return { iframeSrc: `${iframeBaseUrl}${iframePath}`, iframePath };
        }
        if (width && aspectRatio && diameter && dealerSlug && storeId) {
            const iframePath = `/${dealerSlug}/srp/shop-by-size/${width}/${aspectRatio}/${diameter}/${storeId}?isIframe=true&hideLogo=true`;
            return { iframeSrc: `${iframeBaseUrl}${iframePath}`, iframePath };
        }
        throw new Error("Could not load search results because of missing query parameters.");
    }
}
